import { FileText, QrCode, Ruler } from 'lucide-react';

export const LIVE_TOOLS = [
  {
    id: 'resume-builder',
    name: 'Resume Builder',
    shortName: 'Resume',
    tagline: 'ATS-friendly resumes in your browser',
    description:
      'Create professional, ATS-friendly resumes with PDF and Word export. No sign-up, privacy-first, runs entirely in your browser.',
    icon: FileText,
    landingPath: '/tools/resume-builder',
    launchUrl: 'https://resume.pixelutility.com/',
    category: 'Resume Tools',
    screenshotAlt: 'PixelUtility resume builder editor on desktop',
  },
  {
    id: 'qr-code-generator',
    name: 'QR Code Generator',
    shortName: 'QR Code',
    tagline: 'Static QR codes without tracking redirects',
    description:
      'Generate clean static QR codes for WiFi, URLs, business cards, menus, and events. Download PNG or SVG instantly.',
    icon: QrCode,
    landingPath: '/tools/qr-code-generator',
    launchUrl: 'https://qr-code.pixelutility.com/',
    category: 'QR Tools',
    screenshotAlt: 'PixelUtility QR code generator interface',
  },
  {
    id: 'clothing-shoe-size-converter',
    name: 'Clothing & Shoe Size Converter',
    shortName: 'Size Converter',
    tagline: 'US, UK, EU & CM size conversion',
    description:
      'Convert shoe and clothing sizes between US, UK, EU, and centimeters. Brand guides, gender sections, and printable charts.',
    icon: Ruler,
    landingPath: '/tools/clothing-shoe-size-converter',
    launchUrl: 'https://clothing-shoe-size-converter.pixelutility.com/',
    category: 'Productivity',
    screenshotAlt: 'PixelUtility clothing and shoe size converter',
  },
];

export const TOOL_CATEGORIES = [
  {
    name: 'Resume Tools',
    description: 'Build ATS-friendly resumes and export to PDF or Word.',
    toolIds: ['resume-builder'],
  },
  {
    name: 'QR Tools',
    description: 'Create static QR codes for business, WiFi, and print.',
    toolIds: ['qr-code-generator'],
  },
  {
    name: 'Productivity',
    description: 'Everyday converters and utilities that run in the browser.',
    toolIds: ['clothing-shoe-size-converter'],
  },
];

export function getToolById(id) {
  return LIVE_TOOLS.find((t) => t.id === id);
}
